import { render, staticRenderFns } from "./OtherUserTopShelves.vue?vue&type=template&id=f2d883a4&scoped=true&"
import script from "./OtherUserTopShelves.vue?vue&type=script&lang=js&"
export * from "./OtherUserTopShelves.vue?vue&type=script&lang=js&"
import style0 from "./OtherUserTopShelves.vue?vue&type=style&index=0&id=f2d883a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d883a4",
  null
  
)

export default component.exports